export { default } from './ButtonDefault';



// WEBPACK FOOTER //
// ./src/components/Common/Buttons/ButtonDefault/index.js